import React from 'react'
import Select from 'react-select'
import { fnum, sortOpts, getChanges } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import Form from '../ui/Form'

class PRSEditSubTotal extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      delConf: false,
      errors: {}
    };
  }

  savePost = e => {
    e.preventDefault();
    const oldD = this.props.data;
    const { data } = this.state;
    const toSend = getChanges(data, oldD);
    if(!Object.keys(toSend).length) {
      this.props.cancelEdit();
    }
    else {
      toSend.post_id = data.post_id;
      this.props.editPost(toSend, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelEdit();
        const diffP = data.post_price*data.post_qntt - oldD.post_price*oldD.post_qntt;
        this.props.updtBlnc(diffP,diffP,0);
      });
    }
  }

  deletePost = e => {
    e.preventDefault();
    const oldD = this.props.data;
    this.props.editPost({
      post_id: oldD.post_id,
      post_active: 0
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.props.cancelEdit();
      const diffP = -oldD.post_price*oldD.post_qntt;
      this.props.updtBlnc(diffP,diffP,0);
    });
  }

  autoPrice = () => {
    this.setState({
      data:{
        ...this.state.data,
        post_price: this.props.preSum
      }
    });
  }

  render() {
    const { srvgs, srvcs, preSum } = this.props;

    const { data, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deletePost}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var srvcsOpt = [];
    for (var key in srvcs){
      if(srvcs.hasOwnProperty(key) && ((srvcs[key].srvc_active === 1
        && srvgs[srvcs[key].srvc_srvg_id].srvg_subtotal === 1)
        || srvcs[key].srvc_id === data.post_srvc_id)) {
        srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    srvcsOpt.sort(sortOpts);

    const autoBtn = preSum !== data.post_price ?
      <button  type="button" className="btn btn-success btn-sm"
        onClick={this.autoPrice}
        title="Посчитать"
      >
        auto
      </button>
      : '';

    return (
      <tr>
        <td>
          <div className="form-group">
            <button  type="button" className="btn btn-success btn-xs"
              onClick={this.savePost}
              title="Сохранить"
            >
              <span className="glyphicon glyphicon-save"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-default btn-xs"
              onClick={this.props.cancelEdit}
              title="Отменить"
            >
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-danger btn-xs"
              onClick={this.toggleDelConf}
              title="Удалить"
            >
              <span className="glyphicon glyphicon-trash"></span>
            </button>
          </div>
          {delConf}
        </td>
        <td>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Услуга</label>&nbsp;
              <div style={{flex: 1, width: 0}}>
                <Select
                  clearable={false}
                  options={srvcsOpt}
                  value={data.post_srvc_id}
                  onChange={e => this.updateSelect(e,'post_srvc_id')}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              name="post_desc"
              value={data.post_desc}
              rows="4"
              title="Описание"
              placeholder="Описание"
              onChange={this.updateInput}
            />
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control text-editable"
              value={data.post_price}
              name="post_price"
              onChange={this.updateInput}
            />
          </div>
          <div className="form-group">
            {autoBtn}
          </div>
        </td>
        <td className="form-group">1</td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td className="text-right"></td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td className="form-group">
          <textarea type="text"
            className="form-control"
            value={data.post_note}
            rows="3"
            placeholder="Заметка"
            title="Заметка"
            name="post_note"
            onChange={this.updateInput}
          />
        </td>
      </tr>
    );
  }
}

export default PRSEditSubTotal;



// WEBPACK FOOTER //
// ./src/components/prs/PRSEditSubTotal.js